import { TaskStatus } from '@prisma/client';

import { IUseWorkflowStepCompletionsParams } from '@commenda/api/workflow-execution';
import { TWorkflowExecution } from '@commenda/types';
import { ServiceRequestDetails } from '@commenda/types/src/service-request/types';

export class ServiceRequestTaskCompletionHelper {
  static getRequest(
    serviceRequest: Readonly<ServiceRequestDetails>,
    workflowExecution?: TWorkflowExecution
  ): IUseWorkflowStepCompletionsParams {
    const executionIds = Array.from(
      new Set(
        [
          workflowExecution?.id,
          serviceRequest.workflowExecutionId,
          ...serviceRequest.taskGroups.map(
            (group) => group.workflowExecutionId
          ),
        ].filter((id): id is string => !!id)
      )
    ).sort();
    const revision = JSON.stringify([
      serviceRequest.id,
      workflowExecution?.runtime?.lastActivityAt,
      serviceRequest.taskGroups.map((group) =>
        group.tasks.map((task) => [
          task.id,
          task.status,
          task.updatedAt,
          task.completedAt,
        ])
      ),
    ]);
    return { executionIds, revision };
  }

  static getStatusFlags(status: TaskStatus) {
    return {
      isInProgress: status === TaskStatus.IN_PROGRESS,
      isDisabled: status === TaskStatus.BACKLOG,
      isNotStarted: status === TaskStatus.TO_DO,
    };
  }

  static formatCompletedDate(date: Date): string {
    const completed = new Date(date);
    return `${completed.toLocaleString('en-US', { month: 'short' })} ${String(completed.getDate()).padStart(2, '0')}. ${completed.getFullYear()}`;
  }
}
